// prefix
export const PREFIX_CLS = "ve-radio-";

// emit events
export const EMIT_EVENTS = {
    // on radio change
    ON_RADIO_CHANGE: "on-radio-change",
};

// comps name
export const COMPS_NAME = {
    VE_RADIO: "VeRadio",
};
